import type { SVGProps } from 'react'

const InterestGeneratedPlain20 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 13.556L10 9.2782"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.30597V7.25041"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0001 17.2226C13.9888 17.2226 17.2223 13.9891 17.2223 10.0004C17.2223 6.0117 13.9888 2.7782 10.0001 2.7782C6.01133 2.7782 2.77783 6.0117 2.77783 10.0004C2.77783 13.9891 6.01133 17.2226 10.0001 17.2226Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default InterestGeneratedPlain20
